const config =
{
    'apiUrl': process.env.REACT_APP_API_BASE_URL || 'http://api-epiot.s1.ths.agency/public',
    'apiUrlSafelink': process.env.REACT_APP_API_BASE_URL_SAFELINK || 'http://api-epiot.s1.ths.agency/public',
    'isDevelopment': process.env.REACT_APP_IS_DEVELOPMENT
}
export default config